<app-dashboard-admin style="width: inherit;"></app-dashboard-admin>
<section style="background: #f1f1f1; padding-bottom: 4%;">
  <section class="section-css">
    <div class="row">
      <div class="col-sm" style="height: 10px;"></div>
      <div class="col-md" style="height: 20px"></div>
    </div>

    <div class="topnav">
      <a routerLink="#"><i class="fa fa-home" aria-hidden="true"></i></a>
      <a style="color: #6c757d;text-decoration: none;">Manage Leads > <span
          style="color: #337ab7;font-family: 'pt_sans_captionbold';">Manage Leads</span></a>
      <div class="topnav-right">

        <button type="button" class="btn btn-labeled btn-dark" style="margin-right: 10px;padding: 0px;">
          <span class="btn-label"><i class="fa fa-plus-circle" aria-hidden="true"></i></span>&nbsp;<a
            routerLink="/addLeads" class="create-new">Create New</a>
        </button>
        <button type="button" class="btn btn-labeled btn-success" data-toggle="modal" data-target="#exampleModal"
          (click)="clntAsgn('1')" style="margin-right: 10px;">
          <span class="btn-label"><i class="fa fa-check-circle" aria-hidden="true"></i></span>&nbsp;Client Assigned
          To</button>
        <button type="button" class="btn btn-labeled btn-warning" data-toggle="modal" data-target="#changeStatus"
          (click)="clntAsgn('2')" style="margin-right: 10px;color: white;">
          <span class="btn-label"><i class="fa fa-ban" aria-hidden="true"></i></span>&nbsp;Change Status</button>
      </div>
    </div>
  </section>

  <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" *ngIf="shwclient">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Client Assigned To</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <label>Select User</label>
          <select class="custom-select" id="inputGroupSelect02" [(ngModel)]="user">
            <option selected value='0'>...Choose User...</option>
            <option *ngFor="let ult of leadUsrLst" value="{{ult.user_id}}">{{ult.display_email}}</option>
          </select>
        </div>

        <div class="modal-body">
          <label>User Type</label>
          <select class="custom-select" id="inputGroupSelect02" [(ngModel)]="usr_typ" [disabled]="butDisabled">
            <option selected>...Choose User Type...</option>
            <option value="1">Registered</option>
          </select>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-success" (click)="assignClient()"><i class="fa fa-check-circle"
              aria-hidden="true"></i>Assign</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="changeStatus" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1"
    aria-hidden="true" *ngIf="shwstatus">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel1">Client Assigned To</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <label>Select Status</label>
          <select class="custom-select" id="inputGroupSelect02" [(ngModel)]="lead_status">
            <option selected value="0">...Choose Lead Status...</option>
            <option *ngFor="let typ of leadStatus" value="{{typ.id}}">{{typ.name}}</option>
          </select>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-success" (click)="changeLeadStatus()"><i class="fa fa-check-circle"
              aria-hidden="true"></i>Assign</button>
        </div>
      </div>
    </div>
  </div>

  <br>
  <div id="grid" class="grid-styles">
    <div style="color: red;font-size: 13px;padding-left: 17px;">Note&nbsp;:&nbsp;Only perform one action at time either
      Active or In-Active or Delete <span *ngIf="temp.length > 0" class="no-actn-prfmd">No action performed selected
        items
        {{temp.length}}</span></div>
    <dx-data-grid id="grid-container" [dataSource]="leadsLst" [showBorders]="true"
      (onSelectionChanged)="selectionChanged($event)" style="max-width: 100%;" class="grid-table-styles">
      <dxo-search-panel [visible]="true" [width]="300" placeholder="Search..."></dxo-search-panel>
      <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="NewFileName">
      </dxo-export>
      <dxo-selection [selectAllMode]="allMode" [showCheckBoxesMode]="checkBoxesMode" mode="multiple">Check
      </dxo-selection>
      <dxo-paging [pageSize]="10"></dxo-paging>
      <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[5, 10, 20]"></dxo-pager>
      <!-- <dxo-filter-row [visible]="true"></dxo-filter-row> -->
      <dxi-column caption="S.No" [width]="50" cellTemplate="SerialNoTemplate"></dxi-column>
      <div *dxTemplate="let data of 'SerialNoTemplate'">
        {{data.row.rowIndex + 1}}
      </div>
      <dxi-column dataField="ClientName" caption="Client Name" [width]="150"></dxi-column>
      <dxi-column dataField="Mobile" caption="Mobile" [width]="150"></dxi-column>
      <dxi-column dataField="Email" caption="Email" [width]="150"></dxi-column>
      <dxi-column dataField="UserType" caption="User Type" [width]="150"></dxi-column>
      <dxi-column dataField="DataFrom" caption="Data Source" [width]="150"></dxi-column>
      <dxi-column dataField="AssignedTo" caption="Assigned To" [width]="150"></dxi-column>
      <dxi-column dataField="ReAssigned" caption="ReAssigned To" [width]="150"></dxi-column>
      <dxi-column dataField="lead_status" caption="Lead Status" [width]="150"></dxi-column>
      <dxi-column dataField="status_nm" caption="Status" cellTemplate="cellTemplate" [width]="100"></dxi-column>
      <div *dxTemplate="let cell of 'cellTemplate'">
        <div style="color:green" *ngIf="cell.text == 'Active'">{{cell.text}}</div>
        <div style="color:red" *ngIf="cell.text == 'In-Active'">{{cell.text}}</div>
      </div>
    </dx-data-grid>
  </div>
</section>